import "./TerminalCard.css";
function TerminalCard() {
  return (
    <div className="terminalcard">
      <div className="terminal">
        <hgroup className="head">
          <p className="title">

            Python
          </p>

          <button
            className="copy_toggle"
            tabIndex="-1"
            type="button"
            onClick={()=>{
              navigator.clipboard
              .writeText("pip install aser")
            }}
          >
            <svg
              width="16px"
              height="16px"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              strokeLinejoin="round"
              strokeLinecap="round"
              strokeWidth="2"
              stroke="currentColor"
              fill="none"
            >
              <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"></path>
              <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
            </svg>
          </button>
        </hgroup>

        <div className="body">
          <pre className="pre">
            {/* <code>-&nbsp;</code> */}
            {/* <code>npx&nbsp;</code> */}
            <code className="cmd" data-cmd="pip install aser"></code>
          </pre>
        </div>
      </div>
    </div>
  );
}

export default TerminalCard;
